










import { Component, Mixins } from "vue-property-decorator";
import { Point } from "../../domain/drawing";
import { ModelEditableMixin } from "../system/mixins";

@Component
export default class PointEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: Point) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: Point) => T, defaultValue: T) => T;

  get x(): number {
    return this.readPropertyOrDefault(s => s.x, 0);
  }

  set x(value: number) {
    this.writePropertyWhenValid(s => s.x = value);
  }

  get y(): number {
    return this.readPropertyOrDefault(s => s.y, 0);
  }

  set y(value: number) {
    this.writePropertyWhenValid(s => s.y = value);
  }
}
